import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface DirectoryUser {
  id: string;
  username: string;
  email: string | null;
  first_name: string | null;
  last_name: string | null;
  department: string | null;
  title: string | null;
  is_active: boolean;
  external_id: string;
  identity_provider_id: string | null;
}

export const useDirectoryUserSearch = (providerId: string | null, searchQuery: string) => {
  return useQuery({
    queryKey: ['directory_user_search', providerId, searchQuery],
    queryFn: async () => {
      if (!providerId || !searchQuery || searchQuery.length < 2) return [];
      
      const { data, error } = await supabase
        .from('device_users')
        .select('id, username, email, first_name, last_name, department, title, is_active, external_id, identity_provider_id')
        .eq('identity_provider_id', providerId)
        .or(`username.ilike.%${searchQuery}%,email.ilike.%${searchQuery}%,first_name.ilike.%${searchQuery}%,last_name.ilike.%${searchQuery}%`)
        .eq('is_active', true)
        .limit(10);
      
      if (error) throw error;
      return data as DirectoryUser[];
    },
    enabled: !!providerId && !!searchQuery && searchQuery.length >= 2
  });
};
